import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getKey = () => localStorage.getItem("acw_key") || "";
export const setKey = (k) => localStorage.setItem("acw_key", k);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  cfg.headers["X-Panel-Key"] = getKey();
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("acw_key");
      window.dispatchEvent(new Event("acw-unauthorized"));
    }
    return Promise.reject(err);
  }
);

export const api = {
  verifyKey: (key) => axios.get(`${API}/auth/verify`, { headers: { "X-Panel-Key": key } }).then((r) => r.data),
  status: () => client.get("/bot/status").then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  groups: () => client.get("/groups").then((r) => r.data),
  activity: (limit = 50) => client.get(`/activity?limit=${limit}`).then((r) => r.data),
  activate: (body) => client.post("/licenses/activate", body).then((r) => r.data),
  deactivate: (chatId) => client.post("/licenses/deactivate", { chatId }).then((r) => r.data),
  updateConfig: (chatId, body) => client.patch(`/groups/${encodeURIComponent(chatId)}/config`, body).then((r) => r.data),
  generateCodes: (body) => client.post("/licenses/codes/generate", body).then((r) => r.data),
  listCodes: () => client.get("/licenses/codes").then((r) => r.data),
  redeemCode: (code, chatId) => client.post(`/licenses/codes/${encodeURIComponent(code)}/redeem`, { chatId }).then((r) => r.data),
  deleteCode: (code) => client.delete(`/licenses/codes/${encodeURIComponent(code)}`).then((r) => r.data),
  deleteGroup: (chatId) => client.delete(`/groups/${encodeURIComponent(chatId)}`).then((r) => r.data),
  // Centro de Administración y Membresías
  membershipAdmins: () => client.get("/membership/admins").then((r) => r.data),
  createMembershipAdmin: (body) => client.post("/membership/admins", body).then((r) => r.data),
  updateMembershipAdmin: (id, body) => client.patch(`/membership/admins/${encodeURIComponent(id)}`, body).then((r) => r.data),
  deleteMembershipAdmin: (id) => client.delete(`/membership/admins/${encodeURIComponent(id)}`).then((r) => r.data),
  membershipSettings: () => client.get("/membership/settings").then((r) => r.data),
  updateMembershipSettings: (body) => client.patch("/membership/settings", body).then((r) => r.data),
  previewMembershipNotice: (chatId, type, days) =>
    client.get("/membership/preview", { params: { chat_id: chatId, type, ...(days ? { days } : {}) } }).then((r) => r.data),
  membershipHistory: (chatId) =>
    client.get("/membership/history", { params: chatId ? { chat_id: chatId } : {} }).then((r) => r.data),
};
